import BaseStore, { LOADED,LOADING } from 'stores/BaseStore';
import config from 'config';
import HttpClient from 'utils/httpclient';
class OfferStore extends BaseStore {
  constructor () {
    super('offers', 'offer', {site_model : true});
  }

  async allocations(offer_id){
    const params = { site_id: this.getCurrentSiteID() }
    this.entity.readyState = LOADING;
    const { data } = await HttpClient.get(`${config.api}/offer/${offer_id}/allocations`,{ params })
    this.entity.readyState = LOADED;
    return data;
  }
  
  delete (object, cascadeAllocation) {
    return super.delete({ ...object, params: { cascadeAllocation } }, true)
  }
}

export default new OfferStore();
